/* eslint-disable indent */
import { Grid, TextField, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import i18n from 'i18n';
import { AdvisorEnvironmentBehaviorPeriod } from 'modules/advisors/interfaces';
import React from 'react';
import { cyrb53Hash } from 'utils/helpers';
import styles from '../styles';

const useStyles = makeStyles(styles);

export interface Props {
  title: string;
  highlights?: string[];
  data: AdvisorEnvironmentBehaviorPeriod;
  environmentType: string;
}

const BehaviorDetails = ({
  title,
  highlights,
  data,
  environmentType,
}: Props) => {
  const classes = useStyles();

  const items = [
    {
      label: 'ACTIVE_KEY',
      key: 'active',
    },
    {
      label: 'HOUR_KEY',
      key: 'hour',
    },
    {
      label: 'APPLICATION_SERVER_KEY',
      key: 'application_server_mode',
      hidden: environmentType !== 'micro',
    },
    {
      label: 'MARGIN_KEY',
      key: 'licences_margin_percent',
      hidden: environmentType === 'micro',
    },
  ].filter(item => !item.hidden);

  const renderItemValue = ({ key, data }): string => {
    if (key === 'active') {
      return i18n.t(data[key] ? 'YES_KEY' : 'NO_KEY');
    }
    if (key === 'application_server_mode') {
      return i18n.t(`${data[key].toUpperCase()}_KEY`);
    }
    return data[key];
  };

  return (
    <React.Fragment>
      <Grid container spacing={2} data-testid={'autosky-behaviordetails'}>
        <Grid item xs={12}>
          <Typography variant="h6" style={{ marginTop: 8 }}>
            {title}
          </Typography>
        </Grid>

        {!data.active ? (
          <Grid item xs={6}>
            <TextField
              type="onlyRead"
              label={i18n.t('ACTIVATED_KEY')}
              variant="outlined"
              value={i18n.t(data.active ? 'YES_KEY' : 'NO_KEY')}
              className={clsx({
                [classes.inputHighlight]: highlights?.includes('active'),
              })}
              fullWidth
            />
          </Grid>
        ) : (
          items.map(({ label, key }) => (
            <Grid key={`item-${cyrb53Hash(key)}`} item xs={6}>
              <TextField
                type="onlyRead"
                label={i18n.t(label)}
                variant="outlined"
                value={renderItemValue({ key, data })}
                className={clsx({
                  [classes.inputHighlight]: highlights?.includes(key),
                })}
                fullWidth
              />
            </Grid>
          ))
        )}
      </Grid>
    </React.Fragment>
  );
};

export default BehaviorDetails;
